export default {
  // defaults
  IUI_HOST: 'localhost',
  IUI_PORT: 3000,
  DEPLOY_ENV: 'local',

  IUI_AUTH_DOMAIN: 'http://auth.inturn.docker:8082',
  IUI_CORE_API_DOMAIN: 'http://core-api.inturn.docker:8081',
  IUI_GA_TRACKING_CODE: '',
  IUI_GRAPHQL_DOMAIN: 'https://localhost:4000/graphql',
  IUI_NEW_RELIC_APP_ID: '',
  IUI_PROXY_DOMAIN: '',
  IUI_RECAPTCHA_SITE_KEY: '',
  // to be used when on a local env
  IUI_RECAPTCHA_SITE_KEY_DEV: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI',
  IUI_LAUNCHDARKLY_CLIENT_ID: '62e13ca5e693cb11df28c7b3',
  IUI_WS_HOSTNAME: 'notifications.inturn.docker',
  IUI_WS_PORT: 80,

  // process.env vars we use in the app (excluding in webpack.config)
  NODE_ENV: process.env.NODE_ENV,
  IUI_SSL: process.env.IUI_SSL,
  CIRCLE_SHA1: process.env.CIRCLE_SHA1,

  // added by generated config.js
  ...window.INTURN_ENV,
};
